import { ChangeDetectionStrategy, Component, inject, Input, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '@shared/components/button';
import { SvgComponent } from '@shared/components/svg';
import { OperationalStatus, StoreWithUuid } from '@shared/models';
import { DataLayerService } from '@shared/services/data-layer';
import { Opportunity } from '@shared/services/elastic-search/models';
import { LogsService } from '@shared/services/logs';
import { getStoreStatus, StoreStatus } from '@shared/utils';
import { CommonStore, FunnelStore, StoreLocatorStore } from '@stores';

@Component({
  selector: 'app-map-popin',
  imports: [ButtonComponent, TranslatePipe, SvgComponent],
  templateUrl: './map-popin.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MapPopinComponent implements OnInit {
  @Input() store!: StoreWithUuid;
  @Input() opportunity!: Opportunity;
  storeStatus = signal<StoreStatus>(null!);
  operationalStatus = signal<OperationalStatus | undefined>(undefined);
  private readonly storeLocatorStore = inject(StoreLocatorStore);
  readonly hasAppointmentCta = this.storeLocatorStore.select('hasAppointmentCta');
  readonly gtmConfigSelectStoreButton = this.storeLocatorStore.select('gtmConfigSelectStoreButton');
  readonly opportunityContactUrl = this.storeLocatorStore.select('opportunityContactUrl');
  private readonly appointmentFunnel = inject(CommonStore).select('appointmentFunnel');
  private readonly router = inject(Router);
  private readonly funnelStore = inject(FunnelStore);
  private readonly logs = inject(LogsService);
  private readonly dataLayerService = inject(DataLayerService);

  ngOnInit(): void {
    if (this.store) {
      try {
        this.storeStatus.set(getStoreStatus(this.store.weeklyOpeningHours));
        this.logs.debug('MapPopinComponent', 'storeStatus', this.storeStatus());
      } catch (error) {
        this.logs.error('MapPopinComponent', 'Failed to retrieve store hours', error);
      }
    }
  }

  onStoreAppointmentClick(withGtmEvent = false) {
    const url = this.appointmentFunnel()?.urls?.step2;
    if (url) {
      if (withGtmEvent) this.emitGtmEvent();
      this.funnelStore.batchUpdate({
        update: {
          validatedStep: 1,
          storeSelected: this.store,
        },
      });
      void this.router.navigate([url]);
    }
  }

  emitGtmEvent() {
    const gtm = this.gtmConfigSelectStoreButton();
    if (gtm?.event && gtm?.event.length > 0) {
      this.dataLayerService.push({
        event: gtm?.event,
        group: gtm?.group,
        description: gtm?.description,
        context: gtm?.context,
        event_type: 'search',
      });
    }
  }
}
